import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import 'animate.css';

import LogoSmall from '@images/envy/logo-small.svg';
import LogoTiny from '@images/envy/logo-tiny.svg';
import PhoneIcon from '@images/arbol/header/phone-icon.svg';
import MailIcon from '@images/arbol/header/mail-icon.svg';
import GomesLogo from "@images/home/full-logo.svg";

import classNames from 'classnames';
import { StaticImage } from 'gatsby-plugin-image';
import BaseHeader from '@components/Header';
import * as styles from './styles.module.scss';

const getHref = anchor => {
  const path = typeof window === 'undefined' ? '' : location.pathname;

  if (path === '/property/envy') return anchor;

  if (anchor === '#contact') return anchor;

  const unitComponents = ['#news', '#amenities', '#neighborhood'];
  if (
    /\/property\/envy\/[0-9]+\/?$/.test(path) &&
    unitComponents.includes(anchor)
  )
    return anchor;

  return `/property/envy/${anchor}`;
};
const Header = props => {
  return (
    <BaseHeader
      styles={styles}
      transparent={props.transparent}
      headerContent={header => (
        <>
          <div className={classNames(styles.leftContainer, props?.availability ?  styles.showAvailability : styles.noAvailability)}>
            <a href={getHref('#units')} className={classNames(styles.button)}>
              AVAILABILITY
            </a>
          </div>
          <div className={classNames(styles.logoContainer)}>
            <Link to="/property/envy">
              {props.transparent == true &&
              !['mini', 'hidden'].includes(header.state) ? (
                <><LogoTiny className={classNames(styles.logoTiny, styles.mobile)} /><LogoSmall className={classNames(styles.logoSmall, styles.desktop)} /></>
              ) : (
                <LogoTiny className={styles.logoTiny} />
              )}
            </Link>
          </div>
          <div className={classNames(styles.contactContainer, styles.lg)}>
            <a href="tel:9733308859">973 330 8859</a>
            <a href="mailto:envy@bygomes.com">ENVY@BYGOMES.COM</a>
          </div>
          <div className={classNames(styles.contactContainer, styles.sm)}>
            <div className={styles.iconContainer}>
              <a href="tel:9733308859">
                <PhoneIcon />
              </a>
              <a href="mailto:envy@bygomes.com">
                <MailIcon />
              </a>
            </div>
          </div>
        </>
      )}
      expandedContent={handleClose => (
        <>
          <div className={styles.menuList}>
            <a
              href={getHref('#units')}
              onClick={handleClose}
              className={classNames(styles.button, styles.mobile)}
            >
              AVAILABILITY
            </a>
            <ul>
              <li>
                <Link
                  onClick={handleClose}
                  className="link animate__animated"
                  to={getHref('#units')}
                >
                  Units
                </Link>
              </li>
              <li>
                <Link
                  onClick={handleClose}
                  className="link animate__animated"
                  to={getHref('#amenities')}
                >
                  Amenities
                </Link>
              </li>
              <li>
                <Link
                  onClick={handleClose}
                  className="link animate__animated"
                  to={getHref('#neighborhood')}
                >
                  Neighborhood
                </Link>
              </li>
              <li>
                <Link
                  onClick={handleClose}
                  className="link animate__animated"
                  href="/property/envy/coworking/"
                >
                  Coworking
                </Link>
              </li>
              <li>
                <Link
                  onClick={handleClose}
                  className="link animate__animated"
                  to={getHref('#news')}
                >
                  News
                </Link>
              </li>
              <li>
                <Link
                  onClick={handleClose}
                  className="link animate__animated"
                  to={getHref('#contact')}
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <a
                  onClick={handleClose}
                  className="link animate__animated"
                  href="https://envy-by-gomes-rentcafewebsite.securecafe.com/residentservices/envy-by-gomes/userlogin"
                >
                  Residents
                </a>
              </li>
            </ul>
            <div className={styles.gomesLogo}>
              <Link to="/"><GomesLogo /></Link>
            </div>
          </div>
          <div className={styles.imageContainer}>
            <StaticImage
              className={styles.image}
              src="../../../images/envy/landing-page/menu.jpg"
              alt="Group eating on rooftop"
            />
          </div>
        </>
      )}
    />
  );
};

Header.propTypes = {
  transparent: PropTypes.bool.isRequired,
  availability: PropTypes.bool,
};

Header.defaultProps = {
  transparent: true,
  availability: false,
};

export default Header;
